import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { BandeauBenefices } from '@components/bandeau-benefices/models';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-bandeau-benefices',
  imports: [SvgComponent, NgClass],
  templateUrl: './bandeau-benefices.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BandeauBeneficesComponent extends AbstractDynamicComponent<BandeauBenefices> implements OnInit, OnDestroy {
  private readonly renderer2 = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  ngOnInit(): void {
    this.renderer2.addClass(this.document.body, 'pb-[80px]');
  }

  ngOnDestroy(): void {
    this.renderer2.removeClass(this.document.body, 'pb-[80px]');
  }
}
